import { IMDM_ORG_NAME } from "./constants";
export const isImdmClient = client => {
  return (
    client &&
    client.organization &&
    (client.organization.name === "IMDM" ||
      client.organization.name === IMDM_ORG_NAME)
  );
};
